import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 1.5rem' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Política de Privacidade</h1>
      <p style={{ color: 'var(--dark-light)', marginBottom: '2rem', fontSize: '0.9rem' }}>
        Última atualização: Abril de 2026
      </p>

      <div style={{ lineHeight: 1.8, color: 'var(--dark)', fontSize: '0.95rem' }}>

        <Section title="1. Introdução">
          A RifaMaker ("nós", "nosso" ou "Plataforma") valoriza a privacidade dos seus usuários. Esta
          Política de Privacidade descreve como coletamos, utilizamos, armazenamos, compartilhamos e
          protegemos suas informações pessoais quando você utiliza nosso site e serviços, em conformidade
          com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 — LGPD) e demais legislações
          aplicáveis. Ao utilizar a Plataforma, você declara ter lido, compreendido e concordado com as
          práticas descritas nesta Política.
        </Section>

        <Section title="2. Controlador de Dados">
          A RifaMaker é a controladora dos dados pessoais tratados por meio da Plataforma, nos termos do
          art. 5º, inciso VI da LGPD. Para questões relacionadas ao tratamento de seus dados pessoais,
          entre em contato com nosso Encarregado de Proteção de Dados (DPO) pelo e-mail:{' '}
          <a href="mailto:privacidade@rifamaker.com.br" style={{ color: 'var(--primary)' }}>
            privacidade@rifamaker.com.br
          </a>.
        </Section>

        <Section title="3. Dados Pessoais que Coletamos">
          Coletamos os seguintes tipos de dados pessoais:{' '}
          <strong>Dados de cadastro</strong> — nome completo, endereço de e-mail e senha (hash criptográfico)
          fornecidos ao criar uma conta;{' '}
          <strong>Dados de autenticação social</strong> — nome e e-mail obtidos via Google Sign-In, caso
          utilize login social;{' '}
          <strong>Dados de campanha</strong> — título, descrição, preço, quantidade de números, imagens e
          chave PIX fornecidos pelo Organizador ao criar uma campanha;{' '}
          <strong>Dados de participação</strong> — nome e e-mail fornecidos pelo Participante ao adquirir
          cotas;{' '}
          <strong>Comprovantes de pagamento</strong> — imagens de comprovantes PIX enviados durante o processo
          de compra;{' '}
          <strong>Dados técnicos</strong> — endereço IP, tipo de navegador, sistema operacional, páginas
          acessadas, horários de acesso e dados de cookies, coletados automaticamente.
        </Section>

        <Section title="4. Bases Legais para o Tratamento (Art. 7º, LGPD)">
          Tratamos seus dados pessoais com base nas seguintes hipóteses legais:{' '}
          <strong>Execução de contrato</strong> (art. 7º, V) — para fornecer os serviços da Plataforma,
          processar campanhas e participações;{' '}
          <strong>Consentimento</strong> (art. 7º, I) — para envio de comunicações de marketing e uso de
          cookies não essenciais;{' '}
          <strong>Legítimo interesse</strong> (art. 7º, IX) — para melhoria dos serviços, prevenção de
          fraudes e segurança da Plataforma;{' '}
          <strong>Cumprimento de obrigação legal</strong> (art. 7º, II) — para atendimento a requisitos
          legais, fiscais e regulatórios.
        </Section>

        <Section title="5. Finalidades do Tratamento">
          Utilizamos seus dados pessoais para: fornecer, manter e melhorar nossos serviços; processar e
          gerenciar a criação de campanhas e aquisição de cotas; enviar notificações por e-mail relacionadas
          a suas campanhas (confirmação de pagamento, rejeição, sorteio e resultados); permitir a comunicação
          entre Organizadores e Participantes; verificar sua identidade e prevenir fraudes; cumprir obrigações
          legais e regulatórias; gerar estatísticas anônimas e agregadas sobre o uso da Plataforma; e
          garantir a segurança e integridade da Plataforma.
        </Section>

        <Section title="6. Compartilhamento de Dados">
          Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de marketing.
          Podemos compartilhar seus dados nas seguintes situações:{' '}
          <strong>Entre usuários</strong> — nome e e-mail do Participante são compartilhados com o
          Organizador para gestão da campanha, e vice-versa quando necessário;{' '}
          <strong>Provedores de serviço</strong> — utilizamos o Google Cloud Platform (Firebase) para
          hospedagem, armazenamento, autenticação e envio de e-mails. Esses provedores atuam como
          operadores de dados sob nossas instruções;{' '}
          <strong>Obrigação legal</strong> — quando exigido por lei, ordem judicial, determinação de
          autoridade competente ou processo legal;{' '}
          <strong>Proteção de direitos</strong> — para proteger nossos direitos, propriedade ou segurança,
          ou de nossos usuários e do público.
        </Section>

        <Section title="7. Transferência Internacional de Dados">
          Seus dados podem ser processados em servidores localizados fora do Brasil, incluindo nos Estados
          Unidos (Google Cloud Platform). Essas transferências são realizadas em conformidade com o art. 33
          da LGPD, utilizando mecanismos adequados de proteção, como cláusulas contratuais padrão e a
          certificação de segurança dos provedores de serviço.
        </Section>

        <Section title="8. Armazenamento e Segurança">
          Implementamos medidas técnicas e organizacionais adequadas para proteger seus dados pessoais,
          incluindo: criptografia de senhas (hash bcrypt); conexões seguras via HTTPS/TLS; regras granulares
          de acesso ao banco de dados (Firestore Security Rules); autenticação segura via Firebase
          Authentication; monitoramento de acessos e atividades suspeitas; e URLs de acesso temporário para
          arquivos sensíveis. Nenhum método de transmissão pela internet ou armazenamento eletrônico é 100%
          seguro. Em caso de incidente de segurança que possa causar risco ou dano relevante, notificaremos
          os titulares afetados e a Autoridade Nacional de Proteção de Dados (ANPD), conforme art. 48 da LGPD.
        </Section>

        <Section title="9. Retenção de Dados">
          Mantemos seus dados pessoais pelo tempo necessário para cumprir as finalidades descritas nesta
          Política:{' '}
          <strong>Dados da conta</strong> — enquanto a conta estiver ativa;{' '}
          <strong>Dados de campanhas e transações</strong> — por até 5 (cinco) anos após a conclusão, conforme
          requisitos legais, fiscais e regulatórios;{' '}
          <strong>Dados técnicos de acesso</strong> — por até 6 (seis) meses, conforme o Marco Civil da
          Internet (Lei nº 12.965/2014);{' '}
          <strong>Comprovantes de pagamento</strong> — por até 5 (cinco) anos para fins fiscais.{' '}
          Após a exclusão da conta, seus dados serão eliminados ou anonimizados em até 30 (trinta) dias,
          exceto quando a retenção for exigida por lei ou para cumprimento de obrigação legal.
        </Section>

        <Section title="10. Direitos do Titular (Art. 18, LGPD)">
          Em conformidade com a LGPD, você tem os seguintes direitos sobre seus dados pessoais:{' '}
          <strong>(I)</strong> Confirmação da existência de tratamento;{' '}
          <strong>(II)</strong> Acesso aos seus dados pessoais;{' '}
          <strong>(III)</strong> Correção de dados incompletos, inexatos ou desatualizados;{' '}
          <strong>(IV)</strong> Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou
          tratados em desconformidade com a LGPD;{' '}
          <strong>(V)</strong> Portabilidade dos dados a outro fornecedor;{' '}
          <strong>(VI)</strong> Eliminação dos dados tratados com base no consentimento;{' '}
          <strong>(VII)</strong> Informação sobre entidades públicas e privadas com as quais compartilhamos
          seus dados;{' '}
          <strong>(VIII)</strong> Informação sobre a possibilidade de não fornecer consentimento e as
          consequências;{' '}
          <strong>(IX)</strong> Revogação do consentimento a qualquer momento.{' '}
          Para exercer esses direitos, entre em contato pelo e-mail{' '}
          <a href="mailto:privacidade@rifamaker.com.br" style={{ color: 'var(--primary)' }}>
            privacidade@rifamaker.com.br
          </a>{' '}
          ou pela página de{' '}
          <Link to="/contact" style={{ color: 'var(--primary)' }}>Fale Conosco</Link>.{' '}
          Responderemos sua solicitação em até 15 (quinze) dias, conforme art. 18, § 5º da LGPD. Caso
          entenda que o tratamento de seus dados viola a LGPD, você tem direito de apresentar reclamação
          junto à Autoridade Nacional de Proteção de Dados (ANPD).
        </Section>

        <Section title="11. Cookies e Tecnologias de Rastreamento">
          Utilizamos cookies e tecnologias similares para: manter sua sessão de login ativa (cookies
          essenciais); lembrar suas preferências de idioma; melhorar sua experiência na Plataforma; e
          coletar dados analíticos anônimos para melhoria dos serviços. Você pode configurar seu navegador
          para recusar cookies não essenciais, mas isso pode limitar algumas funcionalidades da Plataforma.
          Cookies essenciais são necessários para o funcionamento da Plataforma e não podem ser desabilitados.
        </Section>

        <Section title="12. Menores de Idade">
          A Plataforma não é destinada a menores de 18 (dezoito) anos de idade. Não coletamos
          intencionalmente dados pessoais de menores. Se tomarmos conhecimento de que coletamos dados de
          um menor sem o consentimento dos pais ou responsável legal, tomaremos medidas imediatas para
          excluir essas informações, conforme art. 14 da LGPD.
        </Section>

        <Section title="13. Alterações nesta Política">
          Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças em nossas
          práticas, tecnologias ou requisitos legais. Alterações significativas serão comunicadas por e-mail
          ou aviso na Plataforma com pelo menos 15 (quinze) dias de antecedência. Recomendamos que você
          revise esta página regularmente. O uso continuado da Plataforma após a entrada em vigor das
          alterações constitui aceitação da nova Política.
        </Section>

        <Section title="14. Contato e Encarregado de Dados (DPO)">
          Se você tiver dúvidas, preocupações ou solicitações relacionadas a esta Política de Privacidade
          ou ao tratamento de seus dados pessoais, entre em contato:{' '}
          <strong>Encarregado de Proteção de Dados (DPO):</strong>{' '}
          <a href="mailto:privacidade@rifamaker.com.br" style={{ color: 'var(--primary)' }}>
            privacidade@rifamaker.com.br
          </a>{' '}
          |{' '}
          <strong>Contato geral:</strong>{' '}
          <a href="mailto:contato@rifamaker.com.br" style={{ color: 'var(--primary)' }}>
            contato@rifamaker.com.br
          </a>{' '}
          |{' '}
          <Link to="/contact" style={{ color: 'var(--primary)' }}>Página de Contato</Link>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h2 style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--dark)' }}>{title}</h2>
      <p style={{ margin: 0 }}>{children}</p>
    </div>
  );
}
